export const SEMICOLON_FORMAT = "/index;";
export const QUERY_STRING_FORMAT = "/index?";
export const QUERY_STRING_FORMAT_LOGIN = "/login?client_id";
export const QUERY_STRING_FORMAT_SECOND_FACTOR = "/second-authentication?client_id";
